module.exports = __webpack_public_path__ + "static/media/opp.1118b7b2.png";